import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class OeContainerListItem extends SearchModelBase {
    containerNo: string = '';
    conType: string = '';
    refNo: string = '';
    pickupNo: string = '';
    sealNo: string = '';
    inDate: string | null = null;
    fromInDate: string | null = null;
    toInDate: string | null = null;
    outDate: string | null = null;
    fromOutDate: string | null = null;
    toOutDate: string | null = null;
    emptryReturn: string | null = null;
    fromEmptryReturn: string | null = null;
    toEmptryReturn: string | null = null;
    ord: string | null = null;
    fromOrd: string | null = null;
    toOrd: string | null = null;
    atd: string | null = null;
    fromAtd: string | null = null;
    toAtd: string | null = null;
    rAtd: string | null = null;
    fromRAtd: string | null = null;
    toRAtd: string | null = null;
    rAta: string | null = null;
    fromRAta: string | null = null;
    toRAta: string | null = null;
    puDate: string | null = null;
    fromPuDate: string | null = null;
    toPuDate: string | null = null;
    dcDate: string | null = null;
    fromDcDate: string | null = null;
    toDcDate: string | null = null;
    kgs: number|null = null;
    fromKgs: number|null = null;
    toKgs: number|null = null;
    lbs: number|null = null;
    fromLbs: number|null = null;
    pkgs: number|null = null;
    toPkgs: number|null = null;
    fromPkgs: number|null = null;
    toLbs: number|null = null;
    mblNo: string = '';
    vessel: string = '';
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    id: number = 0;
    oeMblId: number = 0;
    commodity: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true, visible: true, sortable: false}),
        XCol.Create({ col: 1, text: 'Container #', width: 100, dataIndex: 'containerNo', defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'FT', width: 40, dataIndex: 'ft', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, visible: false, noNullOrEmptySearch: true}),
        XCol.Create({ col: 3, text: 'Type', width: 60, dataIndex: 'conType'}),
        XCol.Create({ col: 4, text: 'Seal #', width: 100, dataIndex: 'sealNo'}),
        XCol.Create({ col: 5, text: 'Ref. #', width: 100, dataIndex: 'refNo'}),
        XCol.Create({ col: 6, text: 'MBL #', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 7, text: 'Pickup #', width: 120, dataIndex: 'pickupNo'}),
        XCol.Create({ col: 8, text: 'Vessel Name', width: 120, dataIndex: 'vessel'}),
        XCol.Create({ col: 9, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 10, text: 'Gate In', width: 75, dataIndex: 'inDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 11, text: 'Gate Out', width: 75, dataIndex: 'outDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'Empty Return', width: 100, dataIndex: 'emptryReturn', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 13, text: 'Origin Receipt', width: 75, dataIndex: 'ord', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 14, text: 'ATD', width: 75, dataIndex: 'atd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 15, text: 'Rail ATD', width: 75, dataIndex: 'rAtd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 16, text: 'Rail RTA', width: 75, dataIndex: 'rAta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 17, text: 'Pickup Date', width: 75, dataIndex: 'puDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false,}),
        XCol.Create({ col: 18, text: 'Deliver Date', width: 75, dataIndex: 'dcDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false, }),
        XCol.Create({ col: 19, text: 'Commodity', width: 80, dataIndex: 'commodity'}),
        XCol.Create({ col: 20, text: 'PKGS', width: 60, dataIndex: 'pkgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 21, text: 'KGS', width: 60, dataIndex: 'kgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 22, text: 'LBS', width: 60, dataIndex: 'lbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: OeContainerListItem.prototype.id, orderByAscending: false };

    public static formatData(data: OeContainerListItem[]) {
        return data.map((d: OeContainerListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        inDate: {from: 'fromInDate', to: 'toInDate'},
        outDate: {from: 'fromOutDate', to: 'toOutDate'},
        emptryReturn: {from: 'fromEmptryReturn', to: 'toEmptryReturn'},
        ord: {from: 'fromOrd', to: 'toOrd'},
        atd: {from: 'fromAtd', to: 'toAtd'},
        rAtd: {from: 'fromRAtd', to: 'toRAtd'},
        rAta: {from: 'fromRAta', to: 'toRAta'},
        fromRAta: {from: 'fromRAta', to: 'toRAta'},
        puDate: {from: 'fromPuDate', to: 'toPuDate'},
        ccDate: {from: 'fromDcDate', to: 'toDcDate'},
        pkgs: {from: 'fromPkgs', to: 'toPkgs'},
        kgs: {from: 'fromKgs', to: 'toKgs'},
        lbs: {from: 'fromLbs', to: 'toLbs'},
        eta: {from: 'fromEta', to: 'toEta'},
    }
}
